import * as React from "react";
import {useEffect} from "react";
import {Loading} from "web-com";
import {isWebview} from "utils";
import {useHistory} from "react-router-dom";

const ExitPage = () => {
  const history = useHistory();
  useEffect(() => {
   if (isWebview()) {
    (window as any).Android.exit();
   } else {
      history.replace("/");
   }
  }, []);
  return (
    <Loading active={true}/>
  );
};

export default ExitPage;